module.exports = __webpack_public_path__ + "img/menuIcon13.a1f8508a.png";